/* eslint-disable react/prop-types */
import { Grid, TextField } from "@material-ui/core";
import "./gliGrid.css";
import { GliGridProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/prop-types
const GliGrid = ({ isPrintable, eachBeneficery }: GliGridProps) => {
	if (!eachBeneficery) return <></>;
	return (
		<Grid container spacing={1}>
			<Grid
				item
				xs={4}
				sm={4}
				md={4}
				lg={4}
				xl={4}
				className={
					isPrintable
						? "gli-contignant-benefit-header form-padding-print"
						: "gli-contignant-benefit-header form-padding"
				}
			>
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					className={isPrintable ? "display-flex-row-print" : "display-flex-row"}
				>
					<span className={isPrintable ? "address-field  font-size-sm" : "address-field  font-size-large"}>
						<b>Address</b>
					</span>
					{isPrintable ? (
						<TextField
							className="address-input-field-print print-input"
							// variant="outlined"
							size="small"
							style={{ fontWeight: "bold", width: "200px", paddingLeft: "10px" }}
							disabled
							value={eachBeneficery ? (eachBeneficery.address ? eachBeneficery.address : "") : ""}
						/>
					) : (
						// <TextareaAutosize
						// 	className="address-input-field "
						// 	variant="outlined"
						// 	disabled
						// 	defaultValue={eachBeneficery ? (eachBeneficery.address ? eachBeneficery.address : "") : ""}
						// />
						<TextField
							className="address-input-field"
							variant="outlined"
							disabled
							value={eachBeneficery ? (eachBeneficery.address ? eachBeneficery.address : "") : ""}
						/>
					)}
				</Grid>
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					className={isPrintable ? "display-flex-row-print" : "display-flex-row"}
				>
					<span className={isPrintable ? "name-field  font-size-sm" : "name-field  font-size-large"}>
						<b>Name</b>
					</span>
					{isPrintable ? (
						<TextField
							className="name-input-field print-input"
							style={{ fontWeight: "bold", width: "200px", paddingLeft: "10px" }}
							// variant="outlined"
							size="small"
							disabled
							value={eachBeneficery ? (eachBeneficery.name ? eachBeneficery.name : "") : ""}
						/>
					) : (
						// <TextField
						// 	className="name-input-field print-input"
						// 	style={{ fontWeight: "bold", height: "2px" }}
						// 	variant="outlined"
						// 	disabled
						// 	value={eachBeneficery ? (eachBeneficery.name ? eachBeneficery.name : "") : ""}
						// />
						<TextField
							className="name-input-field "
							variant="outlined"
							disabled
							value={eachBeneficery ? (eachBeneficery.name ? eachBeneficery.name : "") : ""}
						/>
					)}
				</Grid>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={
					isPrintable
						? "gli-contignant-benefit-header2 font-size-sm"
						: "gli-contignant-benefit-header2 form-padding"
				}
			>
				<div className="phone-container">
					{isPrintable ? (
						<TextField
							className="phone-input-field input-field-margin-2 print-input"
							// variant="outlined"
							placeholder="XXX-XX-XX"
							disabled
							value={eachBeneficery ? (eachBeneficery.SSN ? eachBeneficery.SSN : "") : ""}
						/>
					) : (
						<TextField
							className="phone-input-field input-field-margin-2"
							variant="outlined"
							placeholder="XXX-XX-XX"
							disabled
							value={eachBeneficery ? (eachBeneficery.SSN ? eachBeneficery.SSN : "") : ""}
						/>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={
					isPrintable
						? "gli-contignant-benefit-header3 font-size-sm"
						: "gli-contignant-benefit-header3 form-padding"
				}
			>
				<div className="personal-details-container">
					{isPrintable ? (
						<TextField
							className="phone-input-field input-field-margin-2 print-input"
							// variant="outlined"
							disabled
							value={
								eachBeneficery ? (eachBeneficery.relationship ? eachBeneficery.relationship : "") : ""
							}
						/>
					) : (
						<TextField
							className="phone-input-field input-field-margin-2"
							variant="outlined"
							disabled
							value={
								eachBeneficery ? (eachBeneficery.relationship ? eachBeneficery.relationship : "") : ""
							}
						/>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={
					isPrintable
						? "gli-contignant-benefit-header4 font-size-sm"
						: "gli-contignant-benefit-header4 form-padding"
				}
			>
				<div className="dob-value-container ">
					{isPrintable ? (
						<TextField
							className="dob-input-field input-field-margin-2 print-input"
							// variant="outlined"
							disabled
							value={
								eachBeneficery ? (eachBeneficery.date_of_birth ? eachBeneficery.date_of_birth : "") : ""
							}
						/>
					) : (
						<TextField
							className="dob-input-field input-field-margin-2"
							variant="outlined"
							disabled
							value={
								eachBeneficery ? (eachBeneficery.date_of_birth ? eachBeneficery.date_of_birth : "") : ""
							}
						/>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={
					isPrintable
						? "gli-contignant-benefit-header5 font-size-sm"
						: "gli-contignant-benefit-header5 form-padding"
				}
			>
				<div className="percentage-value-container">
					{isPrintable ? (
						<TextField
							className="phone-input-field input-field-margin-2 print-input"
							style={{ fontWeight: "bolder" }}
							// variant="outlined"
							disabled
							value={eachBeneficery ? (eachBeneficery.percentage ? eachBeneficery.percentage : "") : ""}
						/>
					) : (
						<TextField
							className="phone-input-field input-field-margin-2 "
							style={{ fontWeight: "bolder" }}
							variant="outlined"
							disabled
							value={eachBeneficery ? (eachBeneficery.percentage ? eachBeneficery.percentage : "") : ""}
						/>
					)}
				</div>
			</Grid>
		</Grid>
	);
};

export default GliGrid;
